import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExcelRating } from "../../functions/Report.ExportRating";
import { formatRating } from "../../utils/Report.Format";
import { FilterYearOnly } from "../common/ReportFilters";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
} from "../../../../utils/useStyle";

const initialData = {
  level01: { relative: 0, patient: 0 },
  level02: { relative: 0, patient: 0 },
  level03: { relative: 0, patient: 0 },
  level04: { relative: 0, patient: 0 },
  level05: { relative: 0, patient: 0 },
};

const ReportRating = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({ label: "ทุกปี", value: "ALL" });
  const [data, setData] = React.useState(initialData);

  const listTableRating = [
    {
      name: "ระดับ 1",
      relative: data?.level01?.relative,
      healthcare_provider: data?.level01?.patient,
    },
    {
      name: "ระดับ 2",
      relative: data?.level02?.relative,
      healthcare_provider: data?.level02?.patient,
    },
    {
      name: "ระดับ 3",
      relative: data?.level03?.relative,
      healthcare_provider: data?.level03?.patient,
    },
    {
      name: "ระดับ 4",
      relative: data?.level04?.relative,
      healthcare_provider: data?.level04?.patient,
    },
    {
      name: "ระดับ 5",
      relative: data?.level05?.relative,
      healthcare_provider: data?.level05?.patient,
    },
  ];

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getRatingReport({
          year: String(year?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching rating report:", error);
      }
    };
    fetchData();
  }, [year, userDept]);

  return (
    <div className="mb-20">
      <div className="mt-20 mx-10 font-bold text-xl p-2">รายงานความพึงพอใจ</div>
      <hr />
      <div className={SCREENIPAD}>
        <div className={STYLEHEAD}>
          รายงานความพึงพอใจของญาติ และบุคลาการดูแลผู้ป่วย
          <div className={STYLEBODY}>
            แยกตามระดับ (ระดับ 1 พอใจน้อยที่สุด , ระดับ 2 พอใจน้อย , ระดับ 3
            พอใจปานกลาง ,
            <div>
              ระดับ 4 พอใจมาก , ระดับ 5 พอใจมากที่สุด ) ของปี "{year.label}"
            </div>
          </div>
        </div>
        <div className={FLEXDROPDOWN}>
          <FilterYearOnly year={year} setYear={setYear} />
          <ButtonExcel
            onClick={() => {
              ExcelRating(formatRating(data), year, setLoading);
            }}
            loading={loading}
          />
        </div>
      </div>
      <div className={BARCHART}>
        <BarChart
          width={700}
          height={300}
          data={listTableRating}
          margin={{ top: 20, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar label={{ fill: "#111827" }} dataKey="relative" fill="#d9f99d" />
          <Bar
            label={{ fill: "#111827" }}
            dataKey="healthcare_provider"
            fill="#33CC33"
          />
        </BarChart>
      </div>
    </div>
  );
};

export default ReportRating;
